import { CARRIER_SHIPMENT_PROGRESS_STATUS_PRIORITY } from "constants/index";

interface ShipmentProgressCount {
  count: number;
  label: string;
}

export interface ShipmentProgressSummary {
  matchesLoading: boolean;
  notified: ShipmentProgressCount;
  others: ShipmentProgressCount[];
}

/*
  One notified count: every carrier listed in the notified-carriers table.
  Lane matches and notified partners are separate lists with no carrier in
  both, so their lengths add up without counting anyone twice.
  lane_match_count + notified_network_carrier_count would not: the lane match
  count includes partners.
*/
export function getShipmentProgressSummary(
  shipment: CondensedShipment,
  progress: ShipmentProgress,
): ShipmentProgressSummary {
  const notifiedCount =
    progress.match_progress.length + progress.network_progress.length;
  return {
    matchesLoading: !shipment.is_private && progress.lane_match_count === 0,
    notified: {
      count: notifiedCount,
      label: shipment.is_private ? "Partners Notified" : "Carriers Notified",
    },
    others: [
      { count: progress.view_count, label: "Views" },
      { count: progress.no_capacity_count, label: "No truck available" },
      { count: progress.quote_count, label: "Quotes" },
    ],
  };
}

export function getShipmentDetailTableTitle(
  shipment: CondensedShipment,
  progress: ShipmentProgress,
) {
  const { matchesLoading, notified, others } = getShipmentProgressSummary(
    shipment,
    progress,
  );
  const parts = [notified, ...others].map(
    ({ count, label }) => `${count} ${label}`,
  );
  return [...(matchesLoading ? ["Matches Loading.."] : []), ...parts].join(
    " • ",
  );
}

export function sortByCarrierShipmentProgressStatus(
  carrierProgress: CarrierShipmentProgress[],
): CarrierShipmentProgress[] {
  return [...carrierProgress].sort(
    (a, b) =>
      CARRIER_SHIPMENT_PROGRESS_STATUS_PRIORITY[a.status] -
      CARRIER_SHIPMENT_PROGRESS_STATUS_PRIORITY[b.status],
  );
}
